import { defineStore } from 'pinia'
import { userApi } from '@/api/modules/user'

// 清除所有 cookie
function clearAllCookies() {
  const cookies = document.cookie.split(';')
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=')
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim()
    // 删除 cookie，需要设置 path=/ 确保删除所有路径下的同名 cookie
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
    // 尝试删除不同域下的 cookie
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`
  }
}

export const useUserStore = defineStore('user', {
  state: () => ({
    profile: null,
    apikey: null
  }),

  getters: {
    isLoggedIn: (state) => !!state.profile,
    userName: (state) => state.profile?.userName || '',
    nickname: (state) => state.profile?.nickname || state.profile?.userName || '',
    userEmail: (state) => state.profile?.email || '',
    phoneNumber: (state) => state.profile?.phoneNumber || ''
  },

  actions: {
    async prepareLogin(inviteCode) {
      await userApi.prepareLogin(inviteCode)
    },

    async fetchProfile() {
      const data = await userApi.getProfile()
      if (!data) {
        throw new Error('用户信息不存在')
      }
      this.profile = data
      // WebfunnyMonitor 和 WebfunnyEvents 初始化用户信息
      const { sub, preferredUsername, nickname } = data

      if (window.WebfunnyMonitor) {
        window.WebfunnyMonitor.initUser({
          userId: sub, // 用户标识
          userTag: 'orgName', // 用户标签
          nickname: nickname || preferredUsername // 用户昵称
        })
      }

      // 初始化用户信息，可以在获取到userId之后执行
      if (window.WebfunnyEvents && window.WebfunnyEvents.initUser) {
        window.WebfunnyEvents.initUser({
          userId: sub,
          userType: 'user',
          userTag: 'orgName',
          nickname: nickname || preferredUsername
        })
      }
    },

    async fetchCurrentApikey() {
      try {
        const data = await userApi.getCurrentApikey()
        this.apikey = data.apiKey || data
      } catch {
        // 没有 API Key，保持为 null
        this.apikey = null
      }
    },

    async generateApikey(description) {
      const data = await userApi.generateApikey(description)
      this.apikey = data.apiKey
      return data
    },

    async checkApikey(apiKey) {
      return await userApi.checkApikey(apiKey)
    },

    async logout() {
      try {
        await userApi.logout()
      } catch {
        // 接口失败也继续清理本地状态
      }
      this.profile = null
      this.apikey = null
      sessionStorage.clear()
      clearAllCookies()
    }
  }
})
